import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Close } from '@mui/icons-material';
import { Button, IconButton, Modal, TextField } from '@mui/material';

import Loading from "components/Loading";
import styled from 'styled-components';
import { Col, Row } from 'antd';
import { handleCreateStandardExams, handleUpdateStandardExams } from 'store/standardexams/thunks';
import { find, get } from "lodash";


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const ModalContent = styled.div`
  left: 50%;
  width: 45vw;
  max-width: 500px;
  padding: 24px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: visible;
  margin-top: 10px;
`;
const TitleText = styled.span`
    font-size: 20px;
    color: black;
    font-weight: 600;
`;

const EditStandardExamLevel = ({ open, close, data, activeSession, examDSessionata, standard }) => {
    const [loading, setLoading] = useState(false)
    const [examData, setExamData] = useState()
    const dispatch = useDispatch()

    const handleClose = () => {
        close()
    }

    const onCreateOrUpdate = async () => {
        setLoading(true)
        try {
            if (examData && examData.id) {
                await dispatch(handleUpdateStandardExams(examData))
            } else {
                const hasMiddle = find(examDSessionata, ['exam_school', 'middle'])
                await dispatch(handleCreateStandardExams({ 
                    ...examData, 
                    exams: [], 
                    session: activeSession, 
                    exam_school: !hasMiddle ? 'middle' : '' 
                }))
            }
            close()
        } catch (err) {
            console.error('Error creating/updating exam:', err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        setExamData(data)
    }, [data])

    const isDisabled = !get(examData, "displayName") || loading
    
    return (
        <Modal
            open={open}
            onClose={handleClose}
            style={{ height: '100%', width: '100%' }}
        >
            <ModalContent>
                <Row style={{ justifyContent: "space-between", alignItems: "center", marginBottom: '24px' }}>
                    <TitleText>
                        {data ? 'Update Grade Level Exams' : 'Add Grade Level Exams'}
                    </TitleText>
                    <IconButton 
                        onClick={handleClose}
                        sx={{ 
                            padding: '4px',
                            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                        }}
                    >
                        <Close />
                    </IconButton>
                </Row>
                <ModalConfigArea>
                    <Row>
                        <Col span={24}>
                            <div style={{ marginBottom: '24px' }}>
                                <TextField
                                    fullWidth
                                    id="displayName"
                                    name="displayName"
                                    label="Display Name"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    type="text"
                                    variant="outlined"
                                    onChange={e => {
                                        setExamData({ ...examData, displayName: e.target.value })
                                    }}
                                    value={get(examData, "displayName") || ''}
                                    helperText="Enter a name for this grade level exam"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '6px',
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '14px',
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ 
                                display: 'flex', 
                                gap: '12px', 
                                justifyContent: 'flex-end',
                                marginTop: '8px'
                            }}>
                                <Button
                                    onClick={handleClose}
                                    variant="outlined"
                                    disabled={loading}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '6px',
                                        minWidth: '100px',
                                        fontWeight: 500,
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={onCreateOrUpdate}
                                    disabled={isDisabled}
                                    variant="contained" 
                                    color="primary"
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '6px',
                                        minWidth: '120px',
                                        fontWeight: 500,
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                        '&:hover': {
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                        },
                                        '&:disabled': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.12)',
                                        }
                                    }}
                                >
                                    {loading ? <Loading white size={15} /> : (data ? "Update" : "Create")}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </ModalConfigArea>
            </ModalContent>
        </Modal>
    )
}

export default EditStandardExamLevel